var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArgos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.76 61.36",
    width: "29px",
    height: "29px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4991ce;}.cls-2{fill:#1a306f;}.cls-3{fill:#59bded;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.88 42.1 12.65 38.43 0 38.43 7.23 42.1 19.88 42.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.54 45.48 13.89 45.48 45.14 61.36 45.14 54.94 26.54 45.48"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.14,
    y: 17.22,
    width: 10.62,
    height: 44.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.14,
    width: 10.62,
    height: 10.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "45.14 10.8 45.14 10.8 45.14 0 32.46 10.8 45.14 10.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "27.12 15.34 0 38.43 12.65 38.43 39.8 15.34 27.12 15.34"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgos);
export default __webpack_public_path__ + "static/media/argos.45ce9dbcf9a8989bd3b4d6f62ea0e818.svg";
export { ForwardRef as ReactComponent };